import { IconProps } from 'components/ui';
import {
  ListingBookmark,
  ListingBookmarkTypeEnum,
  ListingTypeEnum,
} from 'lib/api/generated';

type ProductData = {
  [key: string]: {
    [key: string]: string;
  };
};

export enum MarketplaceFilterCardEnum {
  MARKETPLACE = 'marketplace',
  MY_BUY_LISTINGS = 'myBuyListings',
  MY_SELL_LISTINGS = 'mySellListings',
}

export const getProductProperties = (
  productCode: string,
  attribute: string
): string => {
  const productData: ProductData = {
    SH: {
      stock_ages: 'sheep_stock_ages',
      stock_gender: 'sheep_gender',
    },
    CT: {
      stock_ages: 'cattle_stock_ages',
      stock_gender: 'cattle_gender',
    },
    GT: {
      stock_ages: 'goat_stock_ages',
      stock_gender: 'goat_gender',
    },
  };

  const product = productData[productCode];
  if (product) {
    const value = product[attribute];
    if (value) {
      return value;
    } else {
      console.error(
        `Attribute '${attribute}' not found for product '${productCode}'.`
      );
      return '';
    }
  } else {
    console.error('Invalid product code.');
    return '';
  }
};

export function arrayContainsSubstring(array: string[], substring: string) {
  substring = substring.toLowerCase();
  for (let i = 0; i < array.length; i++) {
    let item = array[i].toLowerCase();

    // Check if the item contains the substring
    if (item.includes(substring)) {
      // If found, return true
      return true;
    }
  }
  // If not found, return false
  return false;
}

export const CARD_LISTING_STATUS: {
  bookmark: ListingBookmark;
  id: ListingBookmarkTypeEnum | null;
  label: string;
  icon: IconProps['component'];
}[] = [
  {
    id: null,
    bookmark: {
      type: null,
    },
    label: 'New',
    icon: 'NotificationIcon',
  },
  {
    id: ListingBookmarkTypeEnum.Trade,
    bookmark: {
      type: ListingBookmarkTypeEnum.Trade,
    },
    label: 'Possible Trade',
    icon: 'ScaleIcon',
  },
  {
    id: ListingBookmarkTypeEnum.Watch,
    bookmark: {
      type: ListingBookmarkTypeEnum.Watch,
    },
    label: 'Watch',
    icon: 'EyeIcon',
  },
  {
    id: ListingBookmarkTypeEnum.Ignore,
    bookmark: {
      type: ListingBookmarkTypeEnum.Ignore,
    },
    label: 'Hide',
    icon: 'EyeHideIcon',
  },
];

export const FILTER_LISTING_STATUS: {
  bookmark: ListingBookmark;
  id: ListingBookmarkTypeEnum | null;
  label: string;
  icon: IconProps['component'];
}[] = [
  {
    id: null,
    bookmark: {
      type: null,
    },
    label: 'New',
    icon: 'NotificationIcon',
  },
  {
    id: ListingBookmarkTypeEnum.Trade,
    bookmark: {
      type: ListingBookmarkTypeEnum.Trade,
    },
    label: 'Possible Trades',
    icon: 'ScaleIcon',
  },
  {
    id: ListingBookmarkTypeEnum.Watch,
    bookmark: {
      type: ListingBookmarkTypeEnum.Watch,
    },
    label: 'Watchlist',
    icon: 'EyeIcon',
  },
  {
    id: ListingBookmarkTypeEnum.Ignore,
    bookmark: {
      type: ListingBookmarkTypeEnum.Ignore,
    },
    label: 'Hidden',
    icon: 'EyeHideIcon',
  },
];
